<template>
	<div class="ol-sm-12 col-lg-3" :class="{'close-filter': openFilters !== 'search'}">
		<div class="filter__wrapper" :class="{open: 'name' === showList, close: 'name' !== showList}">
			<input type="text"
				   :placeholder="$t('filters.name')"
				   class="filter"
				   :class="{open: 'name' === showList, close: 'name' !== showList}"
				   @click="updateShowList('name')"
				   @input="showList = 'name'"
				   v-model="searchByName"
			>
			<ul v-show="'name' === showList"
				class="filter__list filter__list--long"
			>
				<li class="filter__list-item" @click="removeFilter">{{$t('filters.remove')}}</li>
				<li v-for="item in namesList"
					class="filter__list-item"
					:class="{'filter__list-item--active': $store.getters.isNameActive(item.full_name)}"
					@click="selectFilter(item)"
					v-text="item.full_name"
				/>
			</ul>
		</div>
	</div>
</template>

<script>
	import { mapActions, mapMutations } from 'vuex'
	import sortJudgesByName from '@/assets/js/sortJudgesByName'

	export default {
		props: ['openFilters'],
		data () {
			return {
				showList: '',
				searchByName: ''
			}
		},
		methods: {
			...mapActions(['fetchJudges']),
			...mapMutations(['editFilters']),
			...mapActions(['fetchNames']),
			...mapMutations(['addName']),
			...mapMutations(['removeName']),
			updateShowList (list) {
				if (this.showList === list) {
					this.showList = ''
				} else {
					setTimeout(() => {
						this.showList = list
					}, 0)
				}
			},
			closeFlitersLists (e) {
				const open = document.querySelector('.open')
				if (open && !e.target.matches('.filter__list, .filter__list *')) {
					this.showList = ''
				}
			},
			removeFilter () {
				this.removeName()
				this.fetchJudges()
				this.showList = ''
			},
			selectFilter (item) {
				this.addName(item.full_name)
				this.fetchJudges()
				this.showList = ''
			}
		},
		computed: {
			namesList: function () {
				const inputTest = person => {
					const regExp = new RegExp('^' + this.searchByName, 'i')
					return regExp.test(person.full_name)
				}

				const filterNames = this.$store.state.judges.name.filter(inputTest)

				return sortJudgesByName(filterNames)
			}
		},
		created () {
			window.addEventListener('click', this.closeFlitersLists)
			this.fetchNames()
		},
		beforeDestroy () {
			window.removeEventListener('click', this.closeFlitersLists)
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../../styles/variables.scss";
	@import "../../../styles/filters.scss";

	.filter__list-item {
		text-align: left;
	}
</style>



// WEBPACK FOOTER //
// src/components/JudgesList/Filters/NameFilterComponent.vue